import { combineReducers } from 'redux'
import { firebaseReducer } from 'react-redux-firebase'
import { firestoreReducer } from 'redux-firestore'
import {companyRegisterReducer} from "./redux/register/reducer";
import {myCoordsReducer} from "./redux/coords/reducer";
import {uxEnhanceReducer} from "./redux/uxEnhance/reducer";

const rootReducer = combineReducers({
  firebase: firebaseReducer,
  firestore: firestoreReducer,
  companyRegister: companyRegisterReducer,
  myCoords: myCoordsReducer,
  uxEnhance: uxEnhanceReducer,
})

export default rootReducer
